import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export interface DefaultParameterState {
  isLoading: boolean
  error: string | undefined
  data: any | null
  httpStatus: number | undefined
}

export const initialState: DefaultParameterState = {
  isLoading: false,
  error: undefined,
  data: null,
  httpStatus: 0
}

const addDefaultParameterSlice = createSlice({
  name: 'AddDefaultParameterSlice',
  initialState,
  reducers: {
    addDefaultParameterLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: null,
        httpStatus: 0
      }
    },
    addDefaultParameterUpdateAction: (state, action: PayloadAction<{ data: any, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    addDefaultParameterErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  addDefaultParameterLoadingAction,
  addDefaultParameterUpdateAction,
  addDefaultParameterErrorAction
} = addDefaultParameterSlice.actions

export default addDefaultParameterSlice.reducer
